// Scripting for Android Pre-registration page
import { setupValidation } from '../components/utility/_validation.js';

/*
// Not using RN
// Opt-In Label Help Icon Toggle (stolen from `resources/assets/js/pages/auth.js`)
const Labels = document.querySelectorAll('.OptInLabel');
if (Labels) {
    Labels.forEach((label) => {
       const icon = label.querySelector('.OptInLabel-helpIcon');
       if (icon) {
           icon.addEventListener('click', (e) => {
               e.preventDefault();
               e.stopPropagation();
               label.classList.toggle('is-active');
           });
       }
    });
}
*/

// Opt-In Form Validation (stolen/adapted from `resources/assets/js/pages/auth.js`)
const OptInForm = document.querySelector("#opt-in-form");
if (OptInForm) {
    document.addEventListener('DOMContentLoaded', function () {
        setupValidation(OptInForm, [
            {
                selector: 'input[name="email"]',
                tests: {
                    email: true,
                },
                errorSelector: '.FormInputWrapper-error',
            },
        ] );
    });
}

// Device Search Functionality (migrated/adapted from `Modules/Warframe/Resources/Views/promo/android/android-preregistration.blade.php`)
document.addEventListener("DOMContentLoaded", function () {
    const trans = window?.PageData?.copy['searchResults']; // TODO: code defensively in case PageData or copy is not defined
    const searchInput = document.getElementById("searchInput");
    const searchList = document.getElementById("searchList");
    const searchHelper = document.getElementById("searchHelper");
    const submitBtn = document.getElementById("opt-in-button");
    let debounceTimer;

    if (searchInput) {
        searchInput.addEventListener("keyup", function () {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                submitBtn.disabled = true;
                submitBtn.classList.add('Button--disabled');
                fetchResults(searchInput.value);
            }, 300);
        });
    }

    function fetchResults(query) {
        if (query.length < 3) {
            searchList.innerHTML = "";
            searchHelper.innerHTML = window?.PageData?.copy['searchStart']; // TODO: code defensively in case PageData or copy is not defined
            return;
        }

        function addDeviceToList(name, index, is_fake) {
            const li = document.createElement("li");
            const radio = document.createElement("input");

            radio.type = "radio";
            radio.name = "device";
            radio.value = is_fake? "" : name;
            radio.id = `device_${index}`;
            radio.classList.add("radio-device");

            radio.addEventListener("change", () => {
                // TODO: quick test to disable the button if the new email field is in error
                submitBtn.disabled = false;
                submitBtn.classList.remove('Button--disabled');
            });

            const label = document.createElement("label");
            label.htmlFor = `device_${index}`;
            label.textContent = name;

            li.classList.add("list-group-item");
            li.appendChild(radio);
            li.appendChild(label);
            searchList.appendChild(li);
        }


        // TODO: code defensively in case PageData or routes is not defined
        fetch(`${ window?.PageData?.routes['search'] }?q=${encodeURIComponent(query)}`)
            .then(response => response.json())
            .then(data => {
                searchList.innerHTML = "";
                searchHelper.innerHTML = trans.replace(":count", data.length).replace(":query", query);

                data.forEach((item, index) => {
                    addDeviceToList(item, index, 0);
                })
                addDeviceToList(`${ window?.PageData?.copy['deviceNotFound'] }`, 5000, 1); // TODO: code defensively in case PageData or copy is not defined
            })
            .catch(error => console.error("Error fetching data:", error));
    }
});